import { BloodworkAnalysis, PossibleRootCauseCategory } from '.';

export abstract class Analysis {
    ba: BloodworkAnalysis;
    possibleRootCauseCategories: PossibleRootCauseCategory[];

    constructor(analysis?: Analysis) {
        this.possibleRootCauseCategories = [];

        // This handles copying the simple properties
        if (!analysis) {
            return;
        }
        // This handles copying the simple properties
        Object.keys(analysis).forEach(key => {
            this[key] = analysis[key];
        });
        if (analysis.possibleRootCauseCategories) {
            this.possibleRootCauseCategories = [...analysis.possibleRootCauseCategories];
        }
    }

    init(bloodworkAnalysis: BloodworkAnalysis): Analysis {
        this.ba = bloodworkAnalysis;
        this.reset();
        return this;
    }

    reset() {
        this.possibleRootCauseCategories = [];
    }

    performAnalysis() {
        this.calculateInsights();
    }

    abstract calculateInsights();
}